import React from "react";

const path = "M0,30 C150,55 350,5 600,30 C850,55 1050,5 1200,30 C1350,55 1550,5 1800,30 C2050,55 2250,5 2400,30";

const WaveDivider = () => (
  <div className="wave-wrap" aria-hidden="true">
    <svg className="w1" viewBox="0 0 2400 60" preserveAspectRatio="none"><path d={path} fill="none" stroke="#d4af37" strokeWidth="2.5" /></svg>
    <svg className="w2" viewBox="0 0 2400 60" preserveAspectRatio="none" style={{ top: 10 }}><path d={path} fill="none" stroke="#38a3e0" strokeWidth="2" /></svg>
    <svg className="w3" viewBox="0 0 2400 60" preserveAspectRatio="none" style={{ top: -8 }}><path d={path} fill="none" stroke="#f4d980" strokeWidth="1.5" /></svg>
  </div>
);

export default WaveDivider;
